import { render, staticRenderFns } from "./ProfileProvablyFair.vue?vue&type=template&id=477185a8&"
import script from "./ProfileProvablyFair.vue?vue&type=script&lang=js&"
export * from "./ProfileProvablyFair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports